<template>
  <div class="notFound">
    <NavHeaderBar title="异常" rightArrow />
    <Default
      :imgurl="require('@/assets/img/df-6.png')"
      text="页面不存在"
      :noFound="true"
    >
      <van-button plain type="info" @click="goHome">返回首页</van-button>
    </Default>
  </div>
</template>

<script>
import { routerReplace } from "@/config/locationRouter";
export default {
  name: "NotFound",
  methods: {
    goHome() {
      routerReplace({ path: "/" });
    }
  }
};
</script>

<style lang="scss">
.notFound {
  overflow: hidden;
}
</style>
